import { useEffect, useState } from "react";
import { ShieldCheck, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fileToJpeg } from "@/lib/image";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field } from "@/components/common";

const TYPES = ["BPKB Motor", "BPKB Mobil", "Sertifikat Tanah", "SK Pegawai", "Ijazah", "Kartu Keluarga"];

export const CollateralDialog = ({ loan, onClose, onSaved }) => {
  const [type, setType] = useState("");
  const [shot, setShot] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setType(loan?.collateral_type || ""); setShot(null); }, [loan]);
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    try { const b = await fileToJpeg(f); setShot({ blob: b, url: URL.createObjectURL(b) }); } catch { toast.error("Format foto tidak didukung, gunakan JPG/PNG"); }
  };
  const submit = async (e) => {
    e.preventDefault();
    if (type.trim().length < 2 || !shot) { toast.error("Isi jenis jaminan dan unggah bukti jaminan"); return; }
    const fd = new FormData();
    fd.append("collateral_type", type.trim());
    fd.append("file", shot.blob, "jaminan.jpg");
    setBusy(true);
    try { await api.post(`/loans/${loan.id}/collateral`, fd); toast.success("Jaminan tersimpan"); onSaved(); onClose(); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={Boolean(loan)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="collateral-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" />Jaminan Pinjaman</DialogTitle><DialogDescription>Wajib untuk pinjaman non-harian sebelum dicairkan Kasir.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Jenis Jaminan">
            <Input list="collateral-types" required className="h-11" value={type} onChange={(e) => setType(e.target.value)} placeholder="cth. BPKB Motor" data-testid="collateral-type-input" />
            <datalist id="collateral-types">{TYPES.map((t) => <option key={t} value={t} />)}</datalist>
          </Field>
          <div className="flex flex-wrap gap-2">{TYPES.map((t) => <button key={t} type="button" onClick={() => setType(t)} className="rounded-full border px-3 py-1.5 text-xs hover:border-primary hover:text-primary transition-colors" data-testid={`collateral-chip-${t.replace(/\s/g, "-")}`}>{t}</button>)}</div>
          <Field label="Bukti Jaminan (foto)">
            <label className="flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed p-5 cursor-pointer hover:bg-muted transition-colors min-h-[140px]" data-testid="collateral-upload-label">
              {shot ? <img src={shot.url} alt="Bukti jaminan" className="max-h-40 rounded-xl object-contain" data-testid="collateral-preview" /> : <><Upload className="h-6 w-6 text-muted-foreground" /><span className="text-sm text-muted-foreground">Ketuk untuk foto / unggah</span></>}
              <input type="file" accept="image/*" capture="environment" className="hidden" onChange={onFile} data-testid="collateral-file-input" />
            </label>
          </Field>
          <DialogFooter><Button type="submit" disabled={busy} className="rounded-full h-11 px-6" data-testid="collateral-submit">{busy ? "Mengunggah..." : "Simpan Jaminan"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
